import React from "react";
import { JdsButton } from "../../components/jds/JdsButton";
import "../../components/jds/jds.css";
import "./userDetails.css";

// Modal de confirmação JDS usado pelas ações da página de detalhes do usuário.
const UserDetailsConfirmModal = ({
  message,
  onConfirm,
  onClose,
  isLoading = false,
  confirmLabel = "Confirmar",
  confirmColor = "brand",
  error,
}) => (
  <div className="user-details-modal">
    <div
      className="user-details-modal__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="user-details-modal-title"
    >
      <h2 id="user-details-modal-title" className="jds-title-sm">
        Confirmação
      </h2>
      <p className="user-details-modal__text">{message}</p>
      {error && (
        <p className="text-danger user-details-modal__error" role="alert">
          {error}
        </p>
      )}
      <div className="user-details-modal__actions">
        <JdsButton variant="outlined" color="neutral" onClick={onClose} disabled={isLoading}>
          Cancelar
        </JdsButton>
        <JdsButton color={confirmColor} onClick={onConfirm} disabled={isLoading}>
          {confirmLabel}
        </JdsButton>
      </div>
    </div>
  </div>
);

export default UserDetailsConfirmModal;
